import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { TrackService } from './track.service';

/**
 * This services is decoupled from track-service to avoid circular dependencies
 */
@Injectable({
  providedIn: 'root',
})
export class TrackLoggerService {
  private trackService: TrackService;
  private pendingMessages = [];

  setTrackService(trackService) {
    this.trackService = trackService;
    for (const pending of this.pendingMessages) {
      this.log(pending);
    }
    this.pendingMessages = [];
  }

  log(message) {
    if (environment.isNativeApp) {
      if (this.trackService) {
        console.log(`TrackLoggerService - pushed ${message}`);
        this.trackService.pushPending('exception', {
          exception: `debug: ${message}`,
        });
      } else {
        this.pendingMessages.push(message);
      }
    }
  }
}
